export function isInViewport (element: Element): boolean {
  const rect = element.getBoundingClientRect()
  return (
    rect.top < window.innerHeight &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.right > 0
  )
}

export function observeWhenVisible (
  element: Element,
  onVisible: () => void,
  rootMargin = '100px'
): IntersectionObserver {
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        onVisible()
        observer.disconnect()
        break
      }
    }
  }, { rootMargin })

  observer.observe(element)
  return observer
}
